import { useState } from "react";

import { Box, Typography } from "@mui/material";

import { PuzzlePieceIcon } from "@phosphor-icons/react/dist/ssr";

import { ProblemModal, TabHeader } from "@/components/Luna/features";
import useLesson from "@/contexts/useLesson";

import ProblemItem from "./ProblemItem";

interface Props {
  inRecordedLessonView: boolean;
  isFocused: boolean;
}

const Problems = ({ inRecordedLessonView, isFocused }: Props) => {
  const { lessonInteractionProfile } = useLesson();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProblemIndex, setSelectedProblemIndex] = useState<
    number | null
  >(null);

  const problems =
    lessonInteractionProfile?.realtimeResources?.problems?.filter(
      (problem) => problem.isApproved
    ) || [];
  const sortedProblems = [...problems].reverse();

  const onOpenModal = (index: number) => {
    setSelectedProblemIndex(index);
    setIsModalOpen(true);
  };

  return (
    <Box
      width="100%"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TabHeader
        title="Problems"
        icon={<PuzzlePieceIcon size={16} weight="fill" />}
      />
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0, // Ensures the Box can shrink properly in a flex column
        }}
      >
        {problems?.length < 1 ? (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              px: 4,
            }}
          >
            <Typography
              variant="text15B"
              color="textSecondary"
              textAlign="center"
              sx={{ width: "100%" }}
            >
              No problems available yet.
            </Typography>
            <Typography
              variant="text13L"
              color="textSecondary"
              textAlign="center"
              sx={{ width: "100%" }}
            >
              Your tutor will add problems here to help you understand the
              concepts better.
            </Typography>
          </Box>
        ) : (
          <>
            {sortedProblems.map((problem) => {
              const originalIndex = problems.findIndex(
                (p) => p.id === problem.id
              );

              return (
                <ProblemItem
                  key={problem.id}
                  problem={problem}
                  index={originalIndex}
                  onOpenModal={onOpenModal}
                  isFocused={isFocused}
                />
              );
            })}
          </>
        )}
      </Box>
      {selectedProblemIndex !== null && (
        <ProblemModal
          canSubmit={!inRecordedLessonView}
          problem={problems[selectedProblemIndex]}
          index={selectedProblemIndex}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default Problems;
